import styled from "styled-components";
import { Link } from "react-router-dom";

export const ConfigurationCardLink = styled(Link)`
    display: block;
    text-decoration: none;
    border: 1px solid var(--color-divider-subtle, #e5e7eb);
    border-radius: var(--radius-sm, 8px);
    padding: var(--space-card-padding);
    transition: background-color 0.15s ease, border-color 0.15s ease;

    &:hover {
        background-color: var(--color-background-light);
        border-color: var(--color-accent-dark);
    }

    &:focus-visible {
        outline: none;
        box-shadow: var(--shadow-button-focus, 0 0 0px 2px #fff, 0 0 3px 4px rgba(234, 133, 34, 0.5));
        border-color: var(--color-accent-dark);
    }
`;